export const onTextAreaChange = function (
  value: string,
  attribute: string,
  setAttribute: Function,
  sizeTextArea: number = 500
) {
  if (value.length <= sizeTextArea) {
    setAttribute(value);
  } else if (attribute.length < sizeTextArea) {
    setAttribute(value.slice(0, sizeTextArea));
  }
};
